import Mask from './mask/MaskInput';
import Number from './number/NumberInput';
import Text from './text/TextInput';
import Select from './select/SelectInput';
import Checkbox from './checkbox/CheckboxInput';
import ComplexWrapper from './wrapper/complex/ComplexInputWrapper';
import Field from './field/InputField';
import Image from './image/ImageInput';
import Switch from './switch/SwitchInput'

export default {
  Text,
  Number,
  Mask,
  Select,
  Checkbox,
  ComplexWrapper,
  Field,
  Image,
  Switch,
};
